import _objectWithoutProperties from "/Users/laurogripa/code/kusama/kappasigmamu.github.io/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["camera", "makeDefault", "regress", "domElement", "onChange", "onStart", "onEnd"];
import _extends from '@babel/runtime/helpers/esm/extends';
import { useThree, useFrame } from '@react-three/fiber';
import * as React from 'react';
import { forwardRef, useMemo, useEffect } from 'react';
import { ArcballControls as ArcballControls$1 } from 'three-stdlib';
const ArcballControls = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      camera,
      makeDefault,
      regress,
      domElement,
      onChange,
      onStart,
      onEnd
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  const invalidate = useThree(_ref2 => {
    let {
      invalidate
    } = _ref2;
    return invalidate;
  });
  const defaultCamera = useThree(_ref3 => {
    let {
      camera
    } = _ref3;
    return camera;
  });
  const gl = useThree(_ref4 => {
    let {
      gl
    } = _ref4;
    return gl;
  });
  const events = useThree(_ref5 => {
    let {
      events
    } = _ref5;
    return events;
  });
  const set = useThree(_ref6 => {
    let {
      set
    } = _ref6;
    return set;
  });
  const get = useThree(_ref7 => {
    let {
      get
    } = _ref7;
    return get;
  });
  const performance = useThree(_ref8 => {
    let {
      performance
    } = _ref8;
    return performance;
  });
  const explCamera = camera || defaultCamera;
  const explDomElement = domElement || (typeof events.connected !== 'boolean' ? events.connected : gl.domElement);
  const controls = useMemo(() => new ArcballControls$1(explCamera), [explCamera]);
  useFrame(() => {
    if (controls.enabled) controls.update();
  });
  useEffect(() => {
    const callback = e => {
      invalidate();
      if (regress) performance.regress();
      if (onChange) onChange(e);
    };
    controls.connect(explDomElement);
    controls.addEventListener('change', callback);
    if (onStart) controls.addEventListener('start', onStart);
    if (onEnd) controls.addEventListener('end', onEnd);
    return () => {
      controls.removeEventListener('change', callback);
      if (onStart) controls.removeEventListener('start', onStart);
      if (onEnd) controls.removeEventListener('end', onEnd);
      controls.dispose();
    };
  }, [explDomElement, onChange, onStart, onEnd, regress, controls, invalidate]);
  useEffect(() => {
    if (makeDefault) {
      // @ts-expect-error new in @react-three/fiber@7.0.5
      const old = get().controls; // @ts-expect-error new in @react-three/fiber@7.0.5

      set({
        controls
      }); // @ts-expect-error new in @react-three/fiber@7.0.5

      return () => set({
        controls: old
      });
    }
  }, [makeDefault, controls]);
  return /*#__PURE__*/React.createElement("primitive", _extends({
    ref: ref,
    object: controls
  }, restProps));
});
export { ArcballControls };